import 'vuetify/styles';
import { createVuetify } from 'vuetify';

import { aliases, custom } from '@/icons-custom.js';

import { lightTheme, vuetifyDefaults } from '@/plugins/vuetifyTheme';

const vuetify = createVuetify({
    theme: {
        defaultTheme: 'lightTheme',
        themes: {
            lightTheme,
        },
    },
    icons: {
        defaultSet: 'custom',
        aliases,
        sets: {
            custom,
        },
    },
    defaults: vuetifyDefaults,
});

export default vuetify;
